const totalComments = () => {

    // total des commentaires en Ajax

    let xhttp = new XMLHttpRequest();
    let comments = document.getElementById('panel-comments');
    let title = comments.querySelector('.panel-scroll .panel-intro .title');

    // Response
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            const response = JSON.parse(this.response);
            if (response.data != 0) {
                title.innerHTML = 'Commentaires (' + response.data + ')';
            }
        }
    };

    xhttp.open("POST", pokaa.ajaxurl, true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("action=total_comments&postid=" + comments.getAttribute('data-postid') + "&nonce=" + comments.getAttribute('data-nonce'));

}

export default totalComments;